module.exports = __webpack_public_path__ + "media/images/countryrect/cm-76f574d35464c036e7e88dbd2baf9bfb.svg";